import { apiUpload } from '@app/api/shipments';
import { ShipmentsApiUploadPayloadProps } from '@app/api/shipments/types';
import { useCompanyId } from '@app/hooks/general/useCompanyId';
import { GET_REPORT_QUERY } from '@app/hooks/queries/useGetReportQueries';
import { invalidateQueries } from '@app/utils/tanstack';
import { useMutation } from '@tanstack/react-query';

export default function useApiUploadMutation() {
  const companyId = useCompanyId();
  return useMutation({
    mutationFn: (payload: ShipmentsApiUploadPayloadProps) => apiUpload({ companyId, payload }),
    onSuccess: (response) => {
      invalidateQueries([GET_REPORT_QUERY, response.report_id]);
    },
  });
}
